var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#8492A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04253 9.152C7.03186 8.928 7.0212 8.76533 7.01053 8.664C7.0052 8.584 6.99453 8.38933 6.97853 8.08C6.96253 7.76533 6.95453 7.45067 6.95453 7.136V4.896H8.03453V7.136C8.03453 7.456 8.01586 7.99467 7.97853 8.752L7.95453 9.152H7.04253ZM7.49853 11.088C7.3172 11.088 7.16253 11.0267 7.03453 10.904C6.91186 10.776 6.85053 10.6213 6.85053 10.44C6.85053 10.2693 6.91453 10.1227 7.04253 10C7.17053 9.872 7.32253 9.808 7.49853 9.808C7.6692 9.808 7.81586 9.872 7.93853 10C8.06653 10.1227 8.13053 10.2693 8.13053 10.44C8.13053 10.6213 8.0692 10.776 7.94653 10.904C7.82386 11.0267 7.67453 11.088 7.49853 11.088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.51981003d5c7f391c87525a07ad30cdb.svg";
export { ForwardRef as ReactComponent };